export default function AdminFooter() {
  return <div>AdminFooter</div>;
}
